var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_edit",
    "data-name": "vuesax/outline/edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-2",
    "data-name": "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.75,21.5C2.32,21.5,0,19.18,0,13.75v-6C0,2.32,2.32,0,7.75,0h2a.755.755,0,0,1,.75.75.755.755,0,0,1-.75.75h-2C3.14,1.5,1.5,3.14,1.5,7.75v6C1.5,18.36,3.14,20,7.75,20h6C18.36,20,20,18.36,20,13.75v-2a.75.75,0,0,1,1.5,0v2c0,5.43-2.32,7.75-7.75,7.75Z",
    transform: "translate(1.25 1.25)",
    fill: "#bf8d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.2,16.692a2.241,2.241,0,0,1-1.58-.62,2.254,2.254,0,0,1-.589-1.949l.43-3.01a3.447,3.447,0,0,1,.869-1.74l7.88-7.88a4.33,4.33,0,0,1,3-1.492,4.33,4.33,0,0,1,3,1.492,4.182,4.182,0,0,1,1.48,3.31,4.441,4.441,0,0,1-1.48,2.68l-7.88,7.879a3.456,3.456,0,0,1-1.74.87l-3.01.43A1.693,1.693,0,0,1,2.2,16.692ZM12.2,1.5h0a2.832,2.832,0,0,0-1.927,1.047l-7.88,7.88a2.038,2.038,0,0,0-.45.89l-.43,3.01a.789.789,0,0,0,.17.68.7.7,0,0,0,.51.182,1.243,1.243,0,0,0,.171-.012l3.01-.429a2,2,0,0,0,.89-.45l7.88-7.88a3.063,3.063,0,0,0,1.04-1.77,2.776,2.776,0,0,0-1.04-2.11A2.875,2.875,0,0,0,12.2,1.505Z",
    transform: "translate(6.301 0.998)",
    fill: "#bf8d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.487,6.417A7.937,7.937,0,0,1,.027.957a.76.76,0,0,1,.52-.93.745.745,0,0,1,.92.52,6.425,6.425,0,0,0,4.42,4.42.755.755,0,0,1,.52.93.736.736,0,0,1-.72.55A.645.645,0,0,1,5.487,6.417Z",
    transform: "translate(14.162 3.382)",
    fill: "#bf8d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M24,0V24H0V0Z",
    fill: "#bf8d46",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.71ca01f8696da895009af6a650256733.svg";
export { ForwardRef as ReactComponent };